import { createAction } from '@reduxjs/toolkit';

const domain = 'teamleader/Services/LegacyFeatureFlags';

export const SET_LEGACY_FEATURE_FLAG = `${domain}/SET_LEGACY_FEATURE_FLAG`;

export const setLegacyFeatureFlag = createAction(
  SET_LEGACY_FEATURE_FLAG,
  (key: string, value: 'on' | 'off', extraInfo: string | null) => ({ payload: { key, value, extraInfo } }),
);
